import { Theme } from '@mui/material'
import { COLORS } from 'app-constants'

// for light mode, return black, for dark mode, return white
// isSelected is used in cases where some text on a menu item is selected
// additional documentation found in https://docs.google.com/document/d/17_vz7LQo9Y1-ahMX158ncmBwXGryLJRLDZ3RqJ2KR9c/edit?usp=sharing

type Options = {
  isDarkBackdrop?: boolean
  isSelected?: boolean
  disabled?: boolean
}

export function getColorForDarkMode(theme: Theme, options?: Options) {
  if (options?.isDarkBackdrop === false) {
    return COLORS.GRAY_3
  }

  if (options?.disabled) {
    return COLORS.GRAY_2
  }

  if (options?.isSelected) {
    return theme.palette.mode === 'light' || options.isSelected ? COLORS.GRAY_3 : COLORS.PURE_WHITE
  }

  return theme.palette.mode === 'light' ? COLORS.GRAY_0 : COLORS.PURE_WHITE
}

// this function is used to determine what the color of an element should be
export const getElementColor = (isDarkBackdrop: boolean, theme: Theme) => {
  if (isDarkBackdrop) {
    if (theme.palette.mode === 'light') {
      return COLORS.GRAY_0
    }
    return COLORS.PURE_WHITE
  }
  return COLORS.GRAY_0
}
